import { ReactText } from 'react'
import { ToastOptions, toast } from 'react-toastify'
import SuccessBanner from 'common/Banners/SuccessBanner'
import ErrorBanner from 'common/Banners/ErrorBanner'

type CustomToastHook = {
  showSuccess: (message: string, options?: ToastOptions) => void
  showError: (
    message: string | React.ReactNode,
    options?: ToastOptions,
    showWarningIcon?: boolean
  ) => void
}

// CustomWrapper
const useToast = (isRedesign = false): CustomToastHook => {
  const autoDismissOnClickOutside = (toastId: ReactText) => {
    document.body.addEventListener(
      'click',
      () => {
        toast.dismiss(toastId)
      },
      {
        once: true,
      }
    )
  }

  const showSuccess = (message: string, options?: ToastOptions) => {
    const toastId = toast(
      <SuccessBanner message={message} isRedesign={isRedesign} />,
      {
        position: 'bottom-left',
        hideProgressBar: true,
        closeButton: false,
        ...options,
      }
    )
    autoDismissOnClickOutside(toastId)
    return toastId
  }

  const showError = (
    message: string | React.ReactNode,
    options?: ToastOptions,
    showWarningIcon?: boolean
  ) => {
    const toastId = toast(
      <ErrorBanner
        message={message}
        isRedesign={isRedesign}
        showWarningIcon={showWarningIcon}
      />,
      {
        position: 'bottom-left',
        hideProgressBar: true,
        closeButton: false,
        ...options,
      }
    )
    autoDismissOnClickOutside(toastId)
  }

  return {
    showError,
    showSuccess,
  }
}

export default useToast
